export default __webpack_public_path__ + "static/img/homepage-foreground-men.bd3ce57.png";